function reload_div1() {
  jQuery.post('/cart/add.js', {
    quantity: 1,
    id: jQuery('#ProductSelect-new-product-template').children("option:selected").val()
  });
}

function reload_div2() {
  jQuery("div#side-cart").load(location.href + " div#side-cart>*", "");
}

function toggleHesGalleryClasses() {

  // var viewportWidth = jQuery(window).width();
  // if (viewportWidth < 600) {
  //   console.log('adding hes-gallery class');
  //   jQuery("#has-galler-custom").addClass("hes-gallery");
  // } else {
  //   console.log('removing hes-gallery class');
  //   jQuery("#has-galler-custom").removeClass("hes-gallery");
  // }
}

$(document).ready(function () {

  if($('.glider').length) {
    new Glider(document.querySelector('.glider'), {
      slidesToShow: 3,
      slidesToScroll: 'auto',
      draggable: true,
      dots: '.dots',
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 480,
          settings: {
            // Set to `auto` and provide item width to adjust to viewport
            slidesToShow: 3,
            slidesToScroll: 'auto',
            // itemWidth: 150,
            // duration: 0.25
          }
        },
        {
          // screens greater than >= 775px
          breakpoint: 481,
          settings: {
            // Set to `auto` and provide item width to adjust to viewport
            slidesToShow: 4,
            slidesToScroll: 'auto',
            // itemWidth: 150,
            // duration: 0.25
          }
        },
        {
          // screens greater than >= 1024px
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 'auto',
            // itemWidth: 150,
            // duration: 0.25
          }
        },
        {
          // screens greater than >= 1024px
          breakpoint: 1280,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 'auto',
            // itemWidth: 150,
            // duration: 0.25
          }
        }, 
        {
          // screens greater than >= 1024px
          breakpoint: 1500,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 'auto',
            // itemWidth: 150,
            // duration: 0.25
          }
        }
      ]
    });
  } else {
    console.log('Glider initialization skipped!');
  }
  
  HesGallery.setOptions({
    disableScrolling: false,
    hostedStyles: false,
    animations: true,
    minResolution: 0,

    showImageCount: true,
    wrapAround: true
  });
  HesGallery.init();

  // console.log('initializing slick slider in product page');

  // $('.moble_slick_new').slick({
  //   dots: true,
  //   infinite: false,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   responsive: [{
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });


  jQuery('#ProductSelect').change(function () {
    var selectedOption = jQuery("#ProductSelect option:selected");
    //var selectedSize = jQuery(selectedOption).data('label'); //jQuery.trim(selectedSize.replace("- Sold out", ""));
    var childrenElement = jQuery('button[data-add-to-cart]').children('span');
    var label = jQuery(childrenElement).data('enabled-label');

    if (!jQuery(selectedOption).hasClass('soldout_option')) { // available product
      jQuery('button[data-add-to-cart]').removeAttr('disabled');
      jQuery('button[data-add-to-cart]').css('display', 'block'); // show normal button
      jQuery('#sold_out_btn').addClass('hide'); // hide soldout button
      //jQuery('#myDIV').addClass('hide'); 

    } else { // soldout

      if (jQuery(selectedOption).hasClass('no-inquire')) {
        jQuery('button[data-add-to-cart]').css('display', 'block'); // show normal button
        jQuery('button[data-add-to-cart]').attr('disabled','disabled');
        label = jQuery(childrenElement).data('disabled-label');
        
      } else {
        jQuery('#sold_out_btn').removeClass('hide'); // show soldout button
        jQuery('button[data-add-to-cart]').css('display', 'none'); // hide normal button
        jQuery('button[data-add-to-cart]').removeAttr('disabled');
      }
      // var selectedSize1 = jQuery("#ProductSelect option:selected").val().trim();
      // jQuery('#ProductSelect-new-product-template option[value="' + selectedSize1 + '"]').attr('selected', 'selected');
    }
    jQuery(childrenElement).html(label);
    //jQuery("select#SingleOptionSelector-0").val(selectedSize).trigger('change');

  });
  jQuery('#ProductSelect').trigger('change');

  if (window.outerWidth < 767) {
    $(".myslide").click(function () {
      $(this).parent().children('.useful-links').slideToggle("fast");
      $(this).toggleClass("turn-chevron");
    });
  }

  // set classes on page load
  toggleHesGalleryClasses();

  jQuery(window).resize(function () {
    toggleHesGalleryClasses();
  });

  $(".sub-drop1").click(function () {
    $(".wsmenu-click02").toggleClass("plus-false");
  });

  // click-handler to add selected variant to cart
  jQuery(document).on("click", "button[type='submit']", async function () {
    CartJS.addItem(jQuery('#ProductSelect').children("option:selected").val(), 1, {}, {
      "success": function(data, textStatus, jqXHR) {
        setTimeout(() => {
          openSidebar();}, 500
        );
      }
    });
  });
});
